 
import { routes } from "../../../../routers/routes";
import Breadcrumbs from "../../../commonComponents/breadcrumbs";
import AboutOwn from "../../../home/carDemo1/AboutOwn";
import CarService from "./CarService";

const AboutUs1Container = () => {
  return (
    <>
      <Breadcrumbs title="About Us" url={routes.Home.CarDemo1} mainClass="page-breadcrumbs-section page-breadcrumbs-section-aboutus" />
      <AboutOwn />
      <CarService />
    </>
  );
};

export default AboutUs1Container;
